import React from "react";
import { putWorkflowData } from "api/WorkflowApi";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { resetWorkflowState } from "ReduxStore/Slices/workflowSlice";

export default function CreateAutmationBottamSection() {
  const dispatch = useDispatch();
  const workflowData = useSelector((state) => state.workflowSetter);
  const history = useHistory();

  const handleSubmit = () => {
    var data = {
      name: workflowData.workflowName,
      description: workflowData.workflowDescription,
      rerunOnTrigger: workflowData.workflowRerunFlag,
    };
    putWorkflowData(workflowData.workflowId, data)
      .then((res) => {
        history.push(`/admin/workflow/automationstudio/create`);
      })
      .catch((e) => { });
  };

  const routeChangetocancel = (e) => {
    dispatch(resetWorkflowState());
    history.push(`/admin/workflow/all_workflows`);
  };

  return (
    <div className="previewAudience">
      <input
        type="button"
        className="lg_btn primary mb-2"
        onClick={handleSubmit}
        value="Next"
      />{" "}
      &nbsp;&nbsp;
      {/* <a to="" onClick={previewAudience} className="lg_btn primary mb-2">Preview Audience</a> */}
      <a
        className="lg_btn tertiary"
        onClick={(e) => {
          routeChangetocancel(e);
        }}
      >
        Cancel
      </a>
    </div>
  );
}
